import { FC, useEffect } from 'react';
import { selectUser } from '../../redux/reducers/userSlice';
import { useAppSelector } from '../../redux/hooks';
import { LTS_SHUTOFF_PP_435_WEEKLY_GOAL_FLAG, useWeeklyGoal } from '../../contexts/WeeklyGoalContext';
import { useFlag } from '@unleash/proxy-client-react';
interface Props {
  children: React.ReactNode;
}

const WeeklyGoalQueryWrapper: FC<Props> = ({ children }) => {
  const userRedux = useAppSelector(selectUser);

  const ctx = useWeeklyGoal();
  const isEnabled = !useFlag(LTS_SHUTOFF_PP_435_WEEKLY_GOAL_FLAG);

  useEffect(() => {
    if (!isEnabled || !ctx) return;
    const now = new Date();
    const day = (now.getDay() + 6) % 7;
    ctx.loadQuery(
      {
        studentId: `StudentNode:${userRedux?.id}`,
        fromDate: new Date(new Date(now).setHours(0, 0, 0, 0) - day * 24 * 60 * 60 * 1000).toISOString(),
        toDate: new Date(new Date(now).setHours(23, 59, 59, 999) + (6 - day) * 24 * 60 * 60 * 1000).toISOString(),
      },
      { fetchPolicy: 'store-or-network' },
    );
  }, [isEnabled]);

  return children;
};

export default WeeklyGoalQueryWrapper;
